<div class="notFound_wrapper">
    <div class="container">
        <div class="row">
            <div class="col-12 text-center">
                <img src="../../../assets/images/404.svg" alt="404">
                <h2>Whoops! We couldn’t find what you’re looking for.</h2>
                <p>If you are using a valid link, it could be because we are refreshing<br> 
                    our database, please revisit after two hours.</p>
            </div>
        </div>
    </div>
</div>
